export default {
  control: (styles, {
    isFocused,
    menuIsOpen,
    isDisabled
  }) => {
    return {
      ...styles,
      backgroundColor: isDisabled ? '#eaeaea !important' : '#eaeaea !important',
      boxShadow: isFocused || menuIsOpen ? '0 0 0 1px #c0b4ff' : 'none',
      border: '0px',
      fontSize: '12px',
      borderRadius: '10px 0 0 10px',
      height: '35px',
      minHeight: '35px',
      width: "70px",
      ...(isFocused || menuIsOpen ? {
        border: "0px",
        boxShadow: "0 0 0 1px #c0b4ff inset !important"
      } : {})
    }
  },
  placeholder: (styles, state) => ({
    ...styles,
    color: '#362148 !important'
  }),
  indicatorsContainer: (styles, state) => ({
    ...styles,
    height: '35px',
    paddingRight: "3px"
  }),
  menuPortal: (styles, state) => ({
    ...styles,
    // zIndex: 1000
  }),
  indicatorContainer: (styles, {
    menuIsOpen,
    isFocused
  }) => ({
    ...styles,
    padding: '0px !important',
    height: "30px",
    background: isFocused || menuIsOpen ? "#fff !important" : '#eaeaea !important',
  }),
  indicatorSeparator: (styles, state) => ({
    ...styles,
    display: "none",
  }),
  dropdownIndicator: (styles, {
    isFocused,
    menuIsOpen
  }) => ({
    ...styles,
    color: '#000 !important',
    background: 'transparent !important',
    borderRadius: '0px !important',
    padding: '0px !important',
    height: "13px",
    width: "13px",
    fontSize: "13px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }),
  valueContainer: (styles, state) => ({
    ...styles,
    display: "flex",
    flexDirection: "row",
    overflowX: "hidden",
    paddingTop: '0px',
    paddingBottom: '0px',
    flexWrap: "nowrap",
  }),
  placeholder: (styles, state) => ({
    ...styles,
    color: '#999 !important',
    textAlign: "end",
    right: "5px"
  }),
  multiValue: (styles, state) => ({
    ...styles,
    minWidth: "auto"
  }),
  singleValue: (styles) => ({
    ...styles,
    // height: "25px",
    width: "100%",
    textAlign: "center",
    // lineHeight: "1.4"
  }),
  option: (styles, {
    isFocused,
    isSelected
  }) => {
    return {
      ...styles,
      color: isSelected ? '#fff !important' : '#000000a6 !important',
      padding: '4px 5px',
      alignItems: 'center',
      width: 'auto',
      marginBottom: '0px',
      fontSize: '13px',
      display: 'flex',
      lineHeight: '22px',
      backgroundColor: isSelected ? '#b8acf4' : isFocused ? '#b8acf480' : '#fff',
      '&:hover': {
        backgroundColor: isSelected ? '#b8acf4' : '#b8acf480',
      }
    };
  },
};